import { Store } from 'vuex'

import { NotificationModuleName } from '@/store/modules/modules'

export class NotificationViewModel {
  private store: Store<any>

  constructor(store: Store<any>) {
    this.store = store
  }

  welcome() {
    this.store.dispatch(`${NotificationModuleName}/welcomeNotification`)
  }

  login(userId: string) {
    this.store.dispatch(`${NotificationModuleName}/loginNotification`, { userId })
  }

  logout() {
    this.store.dispatch(`${NotificationModuleName}/logoutNotification`)
  }

  error(error: string) {
    this.store.dispatch(`${NotificationModuleName}/errorNotification`, { error })
  }

  registerReview() {
    this.store.dispatch(`${NotificationModuleName}/registerReviewNotification`)
  }

  invalidReview() {
    this.store.dispatch(`${NotificationModuleName}/invalidReviewNotification`)
  }

  registerReviewError() {
    this.store.dispatch(`${NotificationModuleName}/registerReviewErrorNotification`)
  }

  evaluate(score: number) {
    this.store.dispatch(`${NotificationModuleName}/evaluateReviewNotification`, { score })
  }

  closeEntry() {
    this.store.dispatch(`${NotificationModuleName}/closeEntryNotification`)
  }

  submitReview() {
    this.store.dispatch(`${NotificationModuleName}/submitReviewNotification`)
  }

  async copy() {
    await this.store.dispatch(`${NotificationModuleName}/copyNotification`)
  }

  ac(params: { type: 'Run' | 'Judge'; problemId: string; judgeId: string }) {
    this.store.dispatch(`${NotificationModuleName}/acNotification`, params)
  }

  wrong(params: { status: string; type: 'Run' | 'Judge'; problemId: string; judgeId: string }) {
    this.store.dispatch(`${NotificationModuleName}/wrongNotification`, params)
  }

  freeSpaceResult(params: { showFreeSpaceModal: boolean; problemId: string }) {
    this.store.dispatch(`${NotificationModuleName}/freeSpaceResultNotification`, params)
  }

  openRunning(params: { type: 'Run' | 'Judge'; showFreeSpaceModal: boolean; problemId: string }) {
    this.store.dispatch(`${NotificationModuleName}/openRunningNotification`, params)
  }

  noLogin() {
    this.store.dispatch(`${NotificationModuleName}/noLoginNotification`)
  }

  recommendEntry() {
    this.store.dispatch(`${NotificationModuleName}/recommendEntryNotification`)
  }

  closeRunning() {
    this.store.dispatch(`${NotificationModuleName}/closeRunningNotification`)
  }
}
